export default {
  Coefficient: 0,
  Amount: 1,
};
